'use client'

import { InfoIcon, ClockIcon, CircleAlertIcon } from 'lucide-react'
import { Button } from './ui/button'
// import { useRouter } from "next/navigation"
import React from 'react'

interface CarouselBannerProps {
  type?: 'Hot' | 'Ending Soon' | 'Featured'
  message: string
  buttonText?: string
  buttonAction?: () => void
  buttonHref?: string
}

export function CarouselBanner({
  type = 'Hot',
  message,
  buttonText = 'Verify KYC',
  buttonAction,
  buttonHref,
}: CarouselBannerProps) {
  // const router = useRouter()

  const getAlertStyles = (type: string) => {
    switch (type) {
      case 'Hot':
        return {
          bgColor: 'bg-brand-subtleBG',
          textColor: 'text-brand-primary',
          hoverTextColor: 'hover:text-brand-primary',
          icon: (
            <CircleAlertIcon
              size={20}
              className="text-brand-primary flex-shrink-0 min-w-[20px] min-h-[20px]"
            />
          ),
        }
      case 'Ending Soon':
        return {
          bgColor: 'bg-status-errorBG',
          textColor: 'text-status-error',
          hoverTextColor: 'hover:text-status-error',
          icon: (
            <ClockIcon
              size={20}
              className="text-status-error flex-shrink-0 min-w-[20px] min-h-[20px]"
            />
          ),
        }
      case 'Featured':
        return {
          bgColor: 'bg-brand-infoBG',
          textColor: 'text-status-info',
          hoverTextColor: 'hover:text-status-info',
          icon: (
            <InfoIcon
              size={20}
              className="text-status-info flex-shrink-0 min-w-[20px] min-h-[20px]"
            />
          ),
        }
      default:
        return {
          bgColor: 'bg-brand-infoBG',
          textColor: 'text-status-info',
          hoverTextColor: 'hover:text-status-info',
          icon: (
            <InfoIcon
              size={20}
              className="text-status-info flex-shrink-0 min-w-[20px] min-h-[20px]"
            />
          ),
        }
    }
  }

  const { bgColor, textColor, hoverTextColor, icon } = getAlertStyles(type)

  const handleButtonClick = () => {
    if (buttonAction) {
      buttonAction()
      return
    }
    if (buttonHref) {
      window.open(buttonHref, '_self')
    }
  }

  return (
    <div className={`w-full py-3 rounded-none ${bgColor} ${textColor}`}>
      <div className="mx-auto flex flex-col md:flex-row items-start md:items-center gap-3 justify-start text-sm md:text-base px-4 md:px-8 max-w-6xl md:pl-0">
        <div className="flex items-start gap-3">
          {icon}
          <span
            className="font-medium text-sm"
            style={{ color: textColor.replace('text-', 'var(--') + ')' }}
          >
            {message}
          </span>
        </div>
        <Button
          variant="ghost"
          onClick={handleButtonClick}
          className={`px-3 text-xs leading-3 bg-transparent shadow-none border border-solid border-b border-t border-r py-0 h-7 rounded-md ${textColor} border-current hover:bg-white ${hoverTextColor} ml-7 md:ml-0 whitespace-nowrap`}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  )
}
